import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../services/apiService";

const EditAlbum = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [album, setAlbum] = useState({
    category: "",
    description: "",
    name: "",
    cover: null,
    images: null,
    rfid: "",
  });
  const [previewCover, setPreviewCover] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchAlbum();
  }, []);

  const fetchAlbum = async () => {
    try {
      const response = await apiService.fetchData(`admin/get-album-by-id/${id}`);
      if (!response.error) {
        setAlbum(response.data);
        setPreviewCover(apiService.getFullImageUrl(response.data.cover));
        setPreviewImage(apiService.getFullImageUrl(response.data.image));
      }
    } catch (error) {
      console.error("Error fetching album:", error);
    }
  };

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    if (type === "file") {
      const file = files[0];
      setAlbum({ ...album, [name]: file });
      const imageUrl = URL.createObjectURL(file);
      if (name === "cover") setPreviewCover(imageUrl);
      if (name === "images") setPreviewImage(imageUrl);
    } else {
      setAlbum({ ...album, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("category", album.category);
    formData.append("description", album.description);
    formData.append("name", album.name);
    formData.append("rfid", album.rfid);
    if (album.cover) formData.append("cover", album.cover);
    if (album.images) formData.append("image", album.images);

    try {
      const response = await apiService.putData(`admin/update-album/${id}`, formData, true);
      if (!response.error) {
        navigate("/album");
      }
    } catch (error) {
      console.error("Error updating album:", error);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Edit Album</h4>
            <button className="btn btn-secondary" onClick={() => navigate("/album")}>Back</button>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Category</label>
                <input type="text" name="category" className="form-control" value={album.category} onChange={handleChange} placeholder="Enter Category" />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea name="description" className="form-control" value={album.description} onChange={handleChange} placeholder="Enter Description"></textarea>
              </div>
              <div className="form-group">
                <label>Name</label>
                <input type="text" name="name" className="form-control" value={album.name} onChange={handleChange} placeholder="Enter Name" />
              </div>
              <div className="form-group">
                <label>Cover Image</label>
                <input type="file" name="cover" accept="image/*" className="form-control" onChange={handleChange} />
                {previewCover && (
                  <div className="text-center mt-2">
                    <img src={previewCover} alt="Cover Preview" className="img-thumbnail" style={{ width: "100px", height: "100px" }} />
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Images</label>
                <input type="file" name="images" accept="image/*" className="form-control" onChange={handleChange} />
                {previewImage && (
                  <div className="text-center mt-2">
                    <img src={previewImage} alt="Image Preview" className="img-thumbnail" style={{ width: "100px", height: "100px" }} />
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>RFID</label>
                <input type="text" name="rfid" className="form-control" value={album.rfid} onChange={handleChange} placeholder="Enter RFID" />
              </div>
              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Update Album
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate("/album")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAlbum;
